import { useCallback, useRef } from 'react';

import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import {
  SEARCH_ALERTS_ERROR_TYPE,
  SEARCH_ALERTS_ERROR_BANNER,
} from '@xing-com/crate-jobs-constants';
import { useJobsNwtTracking } from '@xing-com/crate-jobs-tracking';

type SearchParameterUpdates = Record<string, string | null>;

export const useShowSearchAlertErrorBanner = (
  type: keyof typeof SEARCH_ALERTS_ERROR_TYPE,
  nwtPage?: string,
  searchParameterUpdates?: SearchParameterUpdates
): (() => void) => {
  const { setSearchParameters } = useSearchParameter();
  const setSearchParametersRef = useRef(setSearchParameters);
  setSearchParametersRef.current = setSearchParameters;
  const trackNwtEvent = useJobsNwtTracking();

  return useCallback(() => {
    trackNwtEvent({
      eventSchema: 'basic',
      event: 'error_shown',
      element: 'search_alert',
      context:
        type === 'DELETE'
          ? 'search_alert_deactivation_error'
          : `search_alert_activation_error${type === 'DUPLICATED' ? '_exists_already' : ''}`,
      page: nwtPage,
    });

    const normalizedSearchParameterUpdates = Object.fromEntries(
      Object.entries(searchParameterUpdates ?? {}).map(([name, value]) => [
        name,
        value ?? '',
      ])
    );

    setSearchParametersRef.current(
      {
        ...normalizedSearchParameterUpdates,
        [SEARCH_ALERTS_ERROR_BANNER]: SEARCH_ALERTS_ERROR_TYPE[type],
      },
      { removeEmpty: true }
    );
  }, [nwtPage, searchParameterUpdates, trackNwtEvent, type]);
};
